import React, { useRef, useEffect } from 'react';
import './background.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getBackgroundFromPage } from '../../helpers/background';
import { TITLE_SCREEN } from '../../constants/routes';

const Background = props => {
    const { children, page, fontSize } = props;

    const background = getBackgroundFromPage(page);

    const backgroundRef = useRef(null);

    useEffect(() => {
        window.addEventListener('resize', setViewportSize);
        return () => {
            window.removeEventListener('resize', setViewportSize);
        };
    }, []);

    const setViewportSize = () => {
        let vh = window.innerHeight * 0.01;
        let vw = window.innerWidth * 0.01;
        backgroundRef.current.style.setProperty('--vh', `${vh}px`);
        backgroundRef.current.style.setProperty('--vw', `${vw}px`);
    };

    const backgroundClasses = classNames({
        background: true,
        'large-text': fontSize === 'large',
        'x-large-text': fontSize === 'x-large',
    });

    return (
        <div
            className={backgroundClasses}
            ref={backgroundRef}
            style={{ backgroundImage: `url(${background})` }}
        >
            {children}
        </div>
    );
};

Background.defaultProps = {
    page: TITLE_SCREEN,
};

Background.propTypes = {
    page: PropTypes.string.isRequired,
};

export { Background };
